import {
  TRUSTPILOT_REVIEWS_KEY,
  TRUSTPILOT_SCORE_STRING_KEY,
} from "apps/website/constants/variables";
import { ROUTE_SIGN_UP_FLOW } from "apps/website/constants/routes";

import {
  ISectionTextImageSocialProofHeroProps,
} from "../SectionTextImageSocialProofHero";

export const textImageSocialProofHeroData: ISectionTextImageSocialProofHeroProps = {
  title: "A healthier happier cat. One fresh meal at a time.",
  subtitle: "Join the 95% of customers who see a happier, healthier cat after switching to KatKin👇",
  cta: {
    id: "text-video-social-proof-hero-cta",
    name: "TRY NOW WITH 20% OFF",
    to: `${ROUTE_SIGN_UP_FLOW}?discount_code=TRY20`,
  },
  image: {
    src: "/images/dev/components/TextImageSocialProofHero/bmr-hero-image-cat-stares-at-katkin.webp",
    width: 1920,
    height: 1080,
  },
  reviewHeader: `Rated ${TRUSTPILOT_SCORE_STRING_KEY} on Trustpilot`,
  reviewFooter: `${TRUSTPILOT_REVIEWS_KEY} reviews`,
};
